import type { AppInventoryOptionType, AppInventoryState } from '@openx/types/targeting/appInventory';
import { type InventoryAndContentState, InventoryContentOption } from '@openx/types/targeting/inventoryAndContent';
import { type DisplayContextsType, displayContexts } from '@openx/types/targeting/targeting';

export type UseBulkDrawerInitialValueProps = {
  contentOption: InventoryContentOption | AppInventoryOptionType;
  displayContext?: DisplayContextsType;
  targetingParams: InventoryAndContentState | AppInventoryState;
};

export const useBulkDrawerInitialValue = ({
  contentOption,
  targetingParams,
  displayContext,
}: UseBulkDrawerInitialValueProps) => {
  const isTrafficSettingContext = displayContext === displayContexts.TRAFFIC_SET;

  const shouldSetBulkUploadInitialValue =
    contentOption === InventoryContentOption.PUBLISHER_ID ||
    contentOption === InventoryContentOption.INSTANCE_HASH ||
    contentOption === InventoryContentOption.SITE ||
    contentOption === InventoryContentOption.LINE_ITEM_APP_BUNDLE_ID;

  if (!shouldSetBulkUploadInitialValue || targetingParams[contentOption] === null || !isTrafficSettingContext)
    return undefined;

  return targetingParams[contentOption]?.val.join('\n') ?? undefined;
};
